module.exports = __webpack_public_path__ + "4e49f31a605ddbe23cc4fcb3cf63f5b1.pdf";